import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, Divider, Grid, Dialog,
    DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, TextField, MenuItem} from '@material-ui/core';
import  AddIcon  from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';
import { runInThisContext } from 'vm';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        },
    button: {
        margin: theme.spacing.unit,
        padding: 40,
        width: 150, 
        height: 100, 
        },
    fab: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 8,
        },
    fab2: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
        },
    textField: {
        paddingTop: 20,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
        
        },
})

class manageLevels extends Component{
    constructor(props){
        super(props)
        this.state = {
            levelNames: [],
            studentCount: [],
            open: false,
            openDelete: false
        }
    }

   async componentDidMount(){
        const arr = await this.getLevels()
        this.setState({
            levelNames: arr
        })
        console.log(this.state)
     }

    getLevels = async () => {
        try {
            var arr = []; 
            let snapshot = await db.collection('Level').get();
            snapshot.forEach( level => {
                arr.push(level.id)
            })
            console.log(arr)
            return arr
        } catch (e) {
            console.error(e)
        }
    }

     handleClose = (name) => {
         this.setState({
             [name]: false
         })
     }

    hanldeOpen = (name) => { 
        this.setState({
            ...this.state,
            [name]: true
        })
    }

    handleChange = (name) => event => { 
        this.setState({
            ...this.state,
            [name]: event.target.value
        })
        console.log(event.target.value)
    }

    // ↓↓ THIS VERSION OF THE FUNCTION CREATES RANDOM GEN KEYS FOR LEVELS NOT CUSTOMS ↓↓
    // createLevel = (name)  => { 
    //     console.log(this.state.levelName)
    //     console.log(name)
    //     try {
    //         db.collection('Level').add({
    //             'Name': name
    //         }).then(ref => {
    //             console.log('Level created with ref: ' + ref.id)
    //         })
    //     } catch (e){ 
    //         console.error(e)
    //     }
    // }

    createLevel = (name)  => { 
        try {
            const data = {
                field: 'placeholder'
            };

            db.collection('Level').doc(name).set({
                data
            }).then(ref => { 
                console.log('level '+ name + ' created with ref: '+ ref)
                window.location.replace(this.props.match.url + '/' + name )
            })
        } catch (e){ 
            console.error(e)
        }
    }

    deleteLevel = (name) => { 
        console.log(name)
        try { 
            db.collection('Level').doc(name).delete()
                .then(ref =>{ 
                    console.log('level ' + name + ' has been deleted.')
                    window.location.reload()
                })
        } catch (e) {
            console.error(e)
        }
    }

    

    render(){
        const { classes } = this.props;
        return (
            <div >
                <Paper className={classes.root} elevation={1}>
                    <Typography variant='headline'>
                        Manage levels
                    </Typography>
                    
                    <Divider/>
                    <br/>
                    {(this.state.levelNames.length > 0) ?
                    <Grid container 
                        spacing={24}
                        direction='row'
                        justify='space-evenly'
                        alignItems="center"
                    >
                        {this.state.levelNames.map(level => {
                            return (
                                <Grid item xs={4}>
                                    <Button variant='outlined' className={classes.button} onClick={() => window.location.replace(this.props.match.url + '/' + level)}  value={level}>
                                        {level}
                                        
                                    </Button>
                                </Grid>
                            )
                        })} 
                    </Grid>
                    :
                    <div/>
                    }
                    <Button variant='fab' mini color='primary' className={classes.fab} onClick={() => this.hanldeOpen('open')}>
                        <AddIcon/>
                    </Button>
                    <Button variant='fab' mini color='primary' className={classes.fab2} onClick={() => this.hanldeOpen('openDelete')}>
                        <DeleteIcon/>
                    </Button>

                    <Dialog
                        open={this.state.open}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose('open')}
                        aria-labelledby='form-dialog-title'
                    >
                        <DialogTitle id='form=dialog-title'>Create new Level</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Please give your new level a name
                            </DialogContentText>
                            <form className={classes.container}>
                                <TextField
                                    id='levelName'
                                    className={classes.TextField}
                                    value={this.state.levelName}
                                    placeholder='Enter a name here'
                                    defaultValue='Default'
                                    onChange={this.handleChange('levelName')}
                                >
                                </TextField>
                                <br/>
                                <br/>
                                <br/>
                                <Button variant='raised' color='inherit'  align='center' onClick={() => this.createLevel(this.state.levelName)}>
                                    Create Level
                                </Button>
                            </form>
                            
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.openDelete}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose('openDelete')}
                        aria-labelledby='form-dialog-title'
                    >
                        <DialogTitle id='form=dialog-title'>Delete a level</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Which level would you like to delete?
                            </DialogContentText>
                            <form className={classes.container}>
                                <TextField
                                    id='levelDelete'
                                    select
                                    className={classes.TextField}
                                    value={this.state.deleteLevel}
                                    placeholder='Please select one'
                                    onChange={ this.handleChange('deleteLevel')}
                                >
                                    {this.state.levelNames.map(level =>{
                                        return (
                                            <MenuItem key={level} value={level}>
                                                {level}
                                            </MenuItem>
                                        )
                                    })}
                                </TextField>
                                <br/>
                                <br/>
                                <br/>
                                <Button variant='raised' color='inherit'  align='center' onClick={() => this.deleteLevel(this.state.deleteLevel)}>
                                    Delete Level
                                </Button>
                            </form>
                            
                        </DialogContent>
                    </Dialog>
                </Paper>
            </div>
        )
    }
}


manageLevels.propTypes = { 
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(manageLevels);


// WEBPACK FOOTER //
// ./src/admin/manageLevels.jsx